import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { SessionService, BrandsService } from '../../services';
import { Sidebar } from '../../components';
import TableSearch from '../../components/TableSearch';

const BrandsList = () => {
  const [brands, setBrands] = useState([]);
  const [search, setSearch] = useState('');
  const [pageCountShow, setPageCountShow] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageCurrent, setPageCurrent] = useState(0);
  const pageLimit = 100;

  useEffect(() => {
    const getData = async () => {
      const data = await BrandsService.getAllBrands(pageCurrent, pageLimit, search);

      if (data.status === 500) {
        SessionService.clearSession();
      }

      if (data.results) {
        setBrands(() => data.results);
        setPageCount(() => data.count);
        setPageCountShow(() => Math.ceil(data.count / pageLimit));
      }
    };

    getData();
  }, [pageCurrent, search]);

  const handlePageChange = async event => {
    const data = await BrandsService.getAllBrands(event.selected, pageLimit, search);

    if (data.status === 500) {
      SessionService.clearSession();
    }

    if (data.results) {
      setBrands(() => data.results);
      setPageCount(() => data.count);
      setPageCountShow(() => Math.ceil(data.count / pageLimit));
      setPageCurrent(event.selected);
    }
  };

  const handleSearch = async text => {
    setSearch(() => text);

    const data = await BrandsService.getAllBrands(pageCurrent, pageLimit, text);

    if (data.status === 500) {
      SessionService.clearSession();
    }

    if (data.results) {
      setBrands(() => data.results);
      setPageCount(() => data.count);
      setPageCountShow(() => Math.ceil(data.count / pageLimit));
    }
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-col flex-1 w-0 overflow-hidden">
        <main className="relative flex-1 overflow-y-auto focus:outline-none">
          <div className="py-6">
            <div className="w-full px-4 sm:px-6 md:px-8">
              <div className="flex items-center justify-between w-full mt-2 mb-4">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                    />
                  </svg>
                  <h1 className="text-xl font-semibold">Brands {pageCount > 0 && <span>({pageCount})</span>}</h1>
                </div>

                <Link
                  to={'/brands/new'}
                  className="flex p-2 text-xs text-white no-underline bg-black rounded-md hover:bg-gray-800 hover:text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  Add new brand
                </Link>
              </div>

              <TableSearch onChange={handleSearch} />

              <table className="w-full table-auto">
                <thead className="text-xs text-left bg-gray-100 border-b branding-wide">
                  <tr>
                    <th className="p-2 text-left whitespace-nowrap">ID</th>
                    <th className="p-2 text-left whitespace-nowrap">Name</th>
                    <th className="p-2 text-left whitespace-nowrap">Number of models</th>
                  </tr>
                </thead>
                <tbody className="text-sm divide-y divide-gray-300">
                  {brands.length > 0 ? (
                    brands.map(brand => (
                      <tr key={brand._id}>
                        <td className="p-2 text-left whitespace-nowrap">
                          {/* <Link to={brand._id}>{brand._id}</Link> */}
                          <div className="flex items-center">
                            <div className="flex-shrink-0 mr-2 sm:mr-3">
                              <Link to={brand._id}>
                                <img
                                  className={`inline-block rounded-full overflow-clip`}
                                  src={brand.photo}
                                  width="32"
                                  height="32"
                                  alt=""
                                />
                              </Link>
                            </div>
                            {brand.name ? (
                              <div className="font-medium text-gray-800">
                                <Link to={brand._id}>{brand._id}</Link>
                              </div>
                            ) : (
                              '/'
                            )}
                          </div>
                        </td>
                        <td className="p-2 text-left whitespace-nowrap">{brand.name}</td>
                        <td className="p-2 text-left whitespace-nowrap">{brand.models.length}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="p-8 text-center text-gray-400" colSpan={13}>
                        No brands in database
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <ReactPaginate
                breakLabel="..."
                onPageChange={handlePageChange}
                pageRangeDisplayed={pageCount}
                pageCount={pageCountShow}
                previousLabel="< prev"
                nextLabel="next >"
                className="flex items-center my-8"
                pageClassName="bg-gray-100 rounded-md m-1 text-sm font-semibold w-8 h-8 hover:bg-gray-200"
                pageLinkClassName="no-underline w-8 h-8 px-2 py-2 flex justify-center items-center"
                previousClassName="bg-gray-100 rounded-md m-1 text-sm font-semibold h-8 hover:bg-gray-200"
                previousLinkClassName="no-underline h-8 px-2 py-2 flex justify-center items-center"
                nextClassName="bg-gray-100 rounded-md m-1 text-sm font-semibold h-8 hover:bg-gray-200"
                nextLinkClassName="no-underline h-8 px-2 py-2 flex justify-center items-center"
                activeClassName="bg-black"
                activeLinkClassName="text-white"
                disabledClassName="bg-gray-50 hover:bg-gray-50"
                disabledLinkClassName="text-gray-400 hover:text-gray-400"
                renderOnZeroPageCount={null}
              />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default BrandsList;
